export default __webpack_public_path__ + "static/media/stewardess.e9da41ab.svg";